import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import { Card, Dropdown } from 'react-bootstrap';
import AuthCornerImage from 'assets/img/illustrations/authentication-corner.png';
import { breakpoints, capitalize } from 'helpers/utils';
import { topNavbarBreakpoint } from 'config';

const NavbarDropdown = ({ title, children, hrefLink }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const location = useLocation();

  // useEffect(() => {
  //   console.log(location.pathname)
  // }, [location])

  return (
    <Dropdown
      show={dropdownOpen}
      // onToggle={() => setDropdownOpen(!dropdownOpen)}
      // onMouseOver={() => {
      //   let windowWidth = window.innerWidth;
      //   if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
      //     setDropdownOpen(true);
      //   }
      // }}
      onMouseLeave={() => {
        let windowWidth = window.innerWidth;
        if (windowWidth >= breakpoints[topNavbarBreakpoint]) {
          setDropdownOpen(false);
        }
      }}
    >
      {/* <Dropdown.Toggle as={Link} to="#!" className="nav-link fw-semibold">
        {capitalize(title)}
      </Dropdown.Toggle> */}
      <Dropdown as={Link} to={hrefLink}
        className='nav-link fw-bold'
        style={{
          color: location.pathname.includes(hrefLink) ? '#3B82F6' : '#64748B',
          backgroundColor: location.pathname.includes(hrefLink) ? '#EFF6FF' : 'transparent',
          padding: '8px 16px',
          borderRadius: '12px',
          transition: 'all 0.2s ease-in-out',
          margin: '0 4px',
          textDecoration: 'none'
        }}
        onMouseEnter={(e) => {
          if (!location.pathname.includes(hrefLink)) {
            e.target.style.backgroundColor = '#F8FAFC';
            e.target.style.color = '#334155';
          }
        }}
        onMouseLeave={(e) => {
          if (!location.pathname.includes(hrefLink)) {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = '#64748B';
          }
        }}
      >
        {capitalize(title)}
      </Dropdown>
      <Dropdown.Menu className="dropdown-menu-card mt-0 dropdown-caret">
        {/* {children} */}
        <Card
          className={classNames('shadow-none dark__bg-1000', {
            'navbar-card-app': title === 'app',
            'navbar-card-pages': title === 'pages',
            'navbar-card-components': title === 'modules'
          })}
        >
          <Card.Body
            className={classNames('scrollbar max-h-dropdown', {
              'p-0 py-2': title === 'dashboard' || title === 'documentation'
            })}
          >
            {/* {title !== 'dashboard' && title !== 'documentation' && (
              <img
                src={AuthCornerImage}
                alt=""
                className="img-dropdown"
                width={130}
              />
            )} */}
            {children}
          </Card.Body>
        </Card>
      </Dropdown.Menu>
    </Dropdown>
  );
};

NavbarDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default NavbarDropdown;
